import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {SendInBlueApiService} from '../../../services/send-in-blue-api.service';
import {ActivatedRoute} from '@angular/router';
import {
    ConfiguratorLandingPageService,
    ConfiguratorTransactionalEmailService,
    FieldTable,
    GetSmtpTemplateOverviewDTO,
    Table,
    TemplateHtmlDTO,
    TransactionalEmailConfDTO,
    TransactionalEmailEditorDTO
} from '@tj/tj-dmp-lib-api';
import {MessageService} from 'primeng/api';
import {Title} from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';
import {ClipboardService} from '../../../services/clipboard.service';
import {AccountService} from '../../../auth/account.service';
import { landingPageLinkParamName } from '../../../shared/landing-page-link.util';
import { catchError} from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
    selector: 'dmp-popup-transaction-email',
    templateUrl: './popup-transaction-email.component.html',
    styleUrls: ['./popup-transaction-email.component.scss'],
    standalone: false
})
export class PopupTransactionEmailComponent implements OnInit {
    private win: Window;
    private templateId: string;
    public tenant: string;
    public partner: string;
    private id: string;

    public conf: TransactionalEmailConfDTO;
    public tplHtmls: Array<TemplateHtmlDTO>;
    public currentTpl: TemplateHtmlDTO;
    public editor: TransactionalEmailEditorDTO;
    tooglePreview = false;
    private availWidth: number;
    scrollHeightNumber = window.innerHeight - 540;
    scrollHeight = `${this.scrollHeightNumber}px`;
    templateEmail: GetSmtpTemplateOverviewDTO;
    private currentData: any;
    public email: string;
    public lang = 'FR';

    public previewData: {[key: string]: string}
    private previewDebounceTimer: any

    fields: any[];
    landingPageLinks: { variable: string; name: string }[] = [];

    constructor(
        private readonly sendInBlueApiService: SendInBlueApiService,
        private readonly route: ActivatedRoute,
        private readonly configuratorTransactionalEmailService: ConfiguratorTransactionalEmailService,
        private readonly clipboardService: ClipboardService,
        private readonly messageService: MessageService,
        private readonly titleService: Title,
        private readonly translateService: TranslateService,
        private readonly accountService: AccountService,
        private readonly landingPageService: ConfiguratorLandingPageService
    ) {
    }

    ngOnInit(): void {
        this.availWidth = window.outerWidth;
        this.templateId = this.route.snapshot.paramMap.get('templateId');
        this.tenant = this.route.snapshot.paramMap.get('tenant');
        this.id = this.route.snapshot.paramMap.get('id');
        this.partner = this.route.snapshot.queryParams.partner;
        window.addEventListener('beforeunload', e => {
            if (this.win && !this.win.closed) {
                this.win.close();
            }
        });

        this.openSib();

        // Cause indirectement un rafraîchissement constant du tableau de prévisualisation
        // à revoir si on peut faire mieux
        setInterval(() => {
            if (this.win && this.win.closed) {
                window.close();
            }
        }, 100);

        this.load();

    }

    private load() {
        this.tplHtmls = [];
        this.configuratorTransactionalEmailService.getEditorForTransactionalEmailUsingGET(this.tenant, this.partner, this.id).subscribe(res => {
                this.editor = res;
                this.titleService.setTitle('DMP - ' + this.translateService.instant('popup-transactional-email.title'));

                this.initPreviewData();
            }),
            catchError(err => {
                console.error('Error fetching editor or save query', err);
                return of(null);
            })
        this.landingPageService.getAllLandingPagesUsingGET(this.tenant, 0, 100).subscribe(landingPages => {
            this.landingPageLinks = landingPages
                .filter(landingPage => !!landingPage.code && landingPage.withToken)
                .map(landingPage => ({ variable: landingPageLinkParamName(landingPage.code), name: landingPage.name || landingPage.code }))
                .sort((a, b) => a.variable.localeCompare(b.variable));
        });
        this.accountService.getAuthenticationState().subscribe(user => {
            this.email = user?.email;
        });
    }

    public openSib(): void {
        const dmpWidth = 400;
        const sibWidth = screen.width - dmpWidth;
        const sibHeight = screen.height;
        const dmpHeight = screen.height;

        if (this.win && !this.win.closed) {
            this.win.close();
        }
        if (this.win) {
            this.win = null;
        }
        const self = this;
        this.win = window.open(self.sendInBlueApiService.getUrl0penSmtpTemplate(self.templateId),
            'sib', `left=${dmpWidth},top=O,width=${sibWidth},height=${sibHeight}`);
    }

    doCopy(categorie: string, code: string) {
        let text: string;
        if(categorie === 'html'){
            text = `{% autoescape off %}{{params.${categorie}.${code}}}{% endautoescape %}`
        } else {
            text = `{{params.${categorie}.${code}}}`;
        }
        this.clipboardService.copyToClipboard(text).then(() => {
            this.messageService.add({
                severity: 'success',
                summary: text,
                detail: `Copié dans le presse papier`,
            });
        });

    }

     /**
     * Copie une variable Brevo standard dans le presse-papier
     */
    doCopyBrevoVariable(variable: string) {
        this.clipboardService.copyToClipboard(variable).then(() => {
            this.messageService.add({
                severity: 'success',
                summary: variable,
                detail: `Copié dans le presse-papier`,
            });
        });
    }

    getTooltip(item: FieldTable): string {
        let description = '';
        if (item.description) {
            description = `Description : ${item.description} \r`;
        }
        return `Label : ${item.label} \r ${description}
        Cathégorie : ${this.getCategory(item)}
        `;
    }

    private getCategory(item: FieldTable) {
        if (item.categoryField == null) {
            return item.type;
        }
        switch (item.categoryField) {
            case 'TEXT':
                return 'Texte';
            case 'CIVILITY':
                return 'Civilité';
            case 'NUMBER':
                return 'Nombre';
            case 'DATE':
                return 'Date';
            case 'DATE_TIME':
                return 'Date et heure';
            case 'TIME':
                return 'heure';
            case 'IATA_CITY':
                return 'Ville';
            case 'IATA_AIRPORT':
                return 'Aéroport';
            case 'IATA_COUNTRY':
                return 'Pays IATA';
            case 'CARRIER':
                return 'Compagnie';
            case 'AFFILIATION':
                return 'Partenaire';
            case 'LANG':
                return 'Langue';
            case 'COUNTRY':
                return 'Pays';
            case 'BOOLEAN':
                return 'Binaire';
            case 'BOOKING_REFERENCE':
                return 'N° commande';
            case 'EMAIL':
                return 'Courriel';
            case 'MOBILE':
            case 'PHONE':
                return 'numéro de téléphone';
            case 'PRICE':
                return 'Prix';
            case 'PRODUCT_TYPE':
                return 'Type de produit';
        }
    }

    doChange(event: any) {
        let availWidth = null;
        if (event.index === 0) {
            // 1er onglet : editor
            availWidth = this.availWidth;
        } else {
            // 2eme onglet : preview
            availWidth = window.screen.availWidth;
        }

        window.resizeTo(
            availWidth,
            window.screen.availHeight
        );
    }

    doPreview(data: any) {
        this.templateEmail = null;
        this.currentData = data;
        this.doPrivatePreview();
    }

    private doPrivatePreview() {
        if (this.id) {
            const apiData = {
                email: this.email,
                ...this.previewData,
                email_language: this.lang
            };
            this.configuratorTransactionalEmailService.previewTransactionalEmailUsingPOST(this.tenant, this.lang, apiData, this.id).subscribe(res => {
                this.templateEmail = res;
            });
        }
    }

    updateLang(lang: string) {
        this.lang = lang;
        this.doPrivatePreview();
    }

    sendTestMail() {
        const apiData = {
            email: this.email,
            ...this.previewData,
            email_language: this.lang
        };
        this.configuratorTransactionalEmailService.testEmailTransactionalEmailUsingPOST(this.tenant, this.lang, apiData, this.email, this.id).subscribe(res => {
            this.messageService.add({
                severity: 'success',
                summary: this.email,
                detail: `Email envoyé`,
            });
        });
    }

    private initPreviewData(): void {
        this.previewData = {};

        if (this.editor.tables) {
            this.editor.tables.forEach(table => {
                table.fields.forEach(field => {
                    const key = `${table.code}_${field.code}`;
                    this.previewData[key] = this.getDefaultValue(field);
                });
            });
        }
        this.doPrivatePreview();
    }

    private getDefaultValue(field: FieldTable): string {
        switch (field.categoryField) {
            case 'EMAIL':
                return 'exemple@email.com';
            case 'CIVILITY':
                return 'M.';
            case 'NUMBER':
                return '0';
            case 'DATE':
                return new Date().toISOString().split('T')[0];
            case 'DATE_TIME':
                return new Date().toISOString().slice(0, 16);
            case 'TIME':
                return '12:00';
            case 'BOOLEAN':
                return 'true';
            case 'PRICE':
                return '0.00';
            case 'PHONE':
            case 'MOBILE':
                return '+33 6 00 00 00 00';
            case 'BOOKING_REFERENCE':
                return 'ABC123';
            default:
                switch(field.type){
                    case 'DateTime':
                        return new Date().toISOString().split('T')[0];
                    default: 
                        return field.label || field.code || '';
                }
        }
    }

    public getInputType(field: FieldTable): string {
        switch (field.categoryField) {
            case 'EMAIL':
                return 'email';
            case 'NUMBER':
            case 'PRICE':
                return 'number';
            case 'DATE':
                return 'date';
            case 'DATE_TIME':
                return 'datetime-local';
            case 'TIME':
                return 'time';
            case 'PHONE':
            case 'MOBILE':
                return 'tel';
            default:
                return 'text';
        }
    }

    public getPlaceholder(field: FieldTable): string {
        if (field.description) {
            return field.description;
        }
        return field.label || '';
    }

    public onPreviewDataChange(): void {
        // Debounce pour éviter trop d'appels API
        if (this.previewDebounceTimer) {
            clearTimeout(this.previewDebounceTimer);
        }

        this.previewDebounceTimer = setTimeout(() => {
            this.doPrivatePreview();
        }, 500);
    }

    public resetPreviewData(): void {
        this.initPreviewData();
    }

    public getNonTechnicalFields(table: Table) {
        return table.fields.filter(field => field.categoryField !== 'TECHNICAL')
    }


}
